// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBusinessWindturbineSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m10.879 7.223 4.605-5.865c.345-.439 1.04-.068.87.463l-2.292 7.096 2.755 6.868c.208.518-.461.935-.835.521l-4.948-5.475-7.412-1.06c-.553-.08-.58-.867-.034-.984z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="m11 12.285 2 2.213V20h1.5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5H11z"
    />
  </svg>
);
export default SvgBusinessWindturbineSolid;
